import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  pagination: {
    position: 'relative',
    display: 'inline-block',
    textAlign: 'center',
    marginTop: '-50px',
    paddingBottom: '32px',
  },
  table: {
    width: '100%',
    objectFit: 'contain',
    height: 'inherit',
  },
  activeFilter: {
    color: '#3560FF',
  },
  tablesContainer: {
    display: 'flex',
    alignItems: 'auto',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    height: 'calc(100vh - 270px)',
    marginTop: '-70px',
  },
  tableLeft: {
    width: '100%',
    objectFit: 'contain',
    height: 'inherit',
  },
  headerBar: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    minWidth: '610px',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '50px',
    justifyContent: 'start',
  },
  header: {
    marginLeft: '32px',
    marginTop: '20px',
    height: '30px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '20px',
    zIndex: 30,
    color: '#2C2D3E',
    textAlign: 'left',
  },
  sessionName: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
  },
  countAndButtonContainer: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    height: '30px',
    marginLeft: '10px'
  },
  selectedRecordCountDisplay: {
    marginTop: '10px',
  },
  assignAnnotationsButton: {
    marginTop: '-10px',
    marginLeft: '-40px',
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    marginTop: '10px',
    marginRight: '20px'
  },
  annotationsTableCell: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  annotationIcon: {
    margin: '10px',
    cursor: 'pointer',
  }
}));
